export default __webpack_public_path__ + "static/media/DSC04912.bccd8cb6.jpg";